import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const CapitalStatsBar = () => {
  const data = {
    labels: ["Total Investments", "Dividends Paid", "Projected Investments by Dec 2025"],
    datasets: [
      {
        label: "GYD",
        data: [21172867, 7860000, 25910657],
        backgroundColor: [
          "rgba(43, 147, 72, 0.7)",
          "rgba(249, 132, 74, 0.7)",
          "rgba(87, 117, 144, 0.7)",
        ],
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "GYD ($)" }
      }
    }
  };

  return (
    <div className="chart-container">
      <h4>📊Capital Overview</h4>
      <Bar data={data} options={options} />
    </div>
  );
};

export default CapitalStatsBar;
